import {
  formatBuildVersionLabel,
  formatBuildVersionTitle,
  getBuildTimestamp,
} from '@/lib/buildInfo'
import {
  formatNonProductionStageLabel,
  getDeploymentStage,
} from '@/constants/deployment'
import { isFrontFlowOrg } from '@/constants/frontflowOrg'
import { useAuth } from '@/contexts/AuthContext'

/**
 * Fixed footer for the authenticated layout: copyright and branding.
 */
export function AuthenticatedLayoutFooter() {
  const { user } = useAuth()
  const buildTimestamp = getBuildTimestamp()
  const versionLabel = formatBuildVersionLabel(buildTimestamp)
  const versionTitle = formatBuildVersionTitle(buildTimestamp)
  const stage = getDeploymentStage()
  const stackLabel =
    isFrontFlowOrg(user?.tenantId) && stage
      ? formatNonProductionStageLabel(stage)
      : null

  return (
    <footer className="mt-auto w-full border-t border-canvas-border bg-white">
      <div className="mx-auto flex max-w-app items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <p className="text-sm text-gray-600">
          © {new Date().getFullYear()} FrontFlow. All rights reserved.
        </p>
        {(versionLabel || stackLabel) && (
          <div className="flex items-center gap-2">
            {stackLabel && (
              <span
                className="text-[10px] font-medium uppercase tracking-wide text-red-700"
                title={`Running on the ${stackLabel}`}
              >
                [{stackLabel}]
              </span>
            )}
            {versionLabel && versionTitle && (
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="text-[10px] tabular-nums text-gray-600/60 hover:text-gray-600 transition-colors"
                title={versionTitle}
              >
                {versionLabel}
              </a>
            )}
          </div>
        )}
      </div>
    </footer>
  )
}
